/* Ornamint search overlay (sections/orn-search.liquid).
   Opens from [data-orn-search-open] (header search icon) or "/" (not while typing in a field); Esc / backdrop / Cancel close it.
   Live results: Shopify predictive search (/search/suggest.json), products + collections, debounced 150 ms,
   the previous request is aborted when a new one starts. Combobox + listbox semantics, arrows move, Enter opens.
   Focus is trapped while open and returns to the icon that opened it. Motion is CSS only (off with reduced motion). */
(function () {
  'use strict';
  var root = document.querySelector('[data-orn-search]');
  if (!root || root.__orn) return;
  root.__orn = true;

  var panel = root.querySelector('.orn-srch__panel');
  var input = root.querySelector('[data-orn-search-input]');
  var form = root.querySelector('[data-orn-search-form]');
  var clearBtn = root.querySelector('[data-orn-search-clear]');
  var list = root.querySelector('[data-orn-search-list]');
  var title = root.querySelector('[data-orn-search-title]');
  var all = root.querySelector('[data-orn-search-all]');
  var status = root.querySelector('[data-orn-search-status]');
  var empty = root.querySelector('[data-orn-search-empty]');
  var emptyQ = root.querySelector('[data-orn-search-q]');
  var popularHTML = list.innerHTML;
  var defaultTitle = title.getAttribute('data-default') || '';
  var suggestUrl = root.getAttribute('data-suggest-url') || '/search/suggest.json';
  var searchUrl = root.getAttribute('data-search-url') || '/search';
  var moneyFmt = root.getAttribute('data-money') || '{{amount}}';
  var fromFmt = root.getAttribute('data-from') || 'from %s';
  var limit = parseInt(root.getAttribute('data-limit'), 10) || 8;
  var mqMobile = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var opener = null, timer = 0, ctrl = null, seq = 0, active = -1, cache = {}, closeT = 0, lastQ = null;

  function triggers() { return document.querySelectorAll('[data-orn-search-open]'); }
  function visibleTrigger() { return Array.prototype.filter.call(triggers(), function (t) { return t.getClientRects().length > 0; })[0] || triggers()[0] || null; }
  function isOpen() { return root.classList.contains('is-open'); }

  /* ---------- formatting ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(v) {
    var n = Math.round(parseFloat(v) * 100); if (isNaN(n)) return '';
    function fmt(cents, dec, th, ds) {
      var s = (cents / 100).toFixed(dec), p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    }
    return moneyFmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return fmt(n, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(n, 2, "'", '.');
        default: return fmt(n, 2, ',', '.');
      }
    });
  }
  function highlight(text, q) {
    var terms = q.trim().split(/\s+/).filter(Boolean).map(function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!terms.length) return esc(text);
    terms.sort(function (a, b) { return b.length - a.length; });
    var re = new RegExp('(' + terms.join('|') + ')', 'gi'), out = '', i = 0, m;
    while ((m = re.exec(text))) { out += esc(text.slice(i, m.index)) + '<mark>' + esc(m[0]) + '</mark>'; i = m.index + m[0].length; if (!m[0].length) re.lastIndex++; }
    return out + esc(text.slice(i));
  }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function cleanUrl(u) { return u || '#'; }

  /* ---------- rendering ---------- */
  function productHTML(p, i, q) {
    var pmin = parseFloat(p.price_min || p.price), pmax = parseFloat(p.price_max || p.price);
    var cmp = parseFloat(p.compare_at_price_min || 0);
    var now = pmin < pmax ? fromFmt.replace('%s', money(pmin)) : money(pmin);
    var mrp = cmp > pmin ? '<span class="orn-card-price__mrp">MRP <s>' + money(cmp) + '</s></span><span class="orn-card-price__save">You save ' + money(cmp - pmin) + '</span>' : '';
    var fi = p.featured_image || {}, src = fi.url || p.image;
    var pic = src ? '<img src="' + esc(img(src, 300)) + '" srcset="' + esc(img(src, 128)) + ' 128w, ' + esc(img(src, 200)) + ' 200w, ' + esc(img(src, 300)) + ' 300w, ' + esc(img(src, 400)) + ' 400w" sizes="(min-width: 750px) 220px, 64px" alt="" loading="lazy" width="400" height="400">' : '';
    var cat = [p.type, p.available === false ? 'Sold out' : ''].filter(Boolean).join(' · ');
    return '<a class="orn-srch__item" role="option" aria-selected="false" id="OrnSearchP' + i + '" href="' + esc(cleanUrl(p.url)) + '" style="--d:' + (i * 45) + 'ms">' +
      '<span class="orn-srch__img">' + pic + '</span>' +
      '<span class="orn-srch__txt">' + (cat ? '<span class="orn-srch__cat-line">' + esc(cat) + '</span>' : '') + '<span class="orn-srch__name">' + highlight(p.title, q) + '</span></span>' +
      '<span class="orn-srch__price orn-card-price"><span class="orn-card-price__now">' + esc(now) + '</span>' + mrp + '</span></a>';
  }
  function collectionHTML(c, i, q) {
    return '<a class="orn-srch__coll" role="option" aria-selected="false" id="OrnSearchC' + i + '" href="' + esc(cleanUrl(c.url)) + '">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>' +
      '<span>' + highlight(c.title, q) + '</span></a>';
  }
  function options() { return list.querySelectorAll('[role="option"]'); }
  function setActive(i) {
    var o = options();
    if (active > -1 && o[active]) { o[active].classList.remove('is-active'); o[active].setAttribute('aria-selected', 'false'); }
    active = o.length ? i : -1;
    if (active > -1) {
      o[active].classList.add('is-active'); o[active].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', o[active].id);
      o[active].scrollIntoView({ block: 'nearest' });
    } else input.removeAttribute('aria-activedescendant');
  }
  function syncExpanded() { input.setAttribute('aria-expanded', options().length ? 'true' : 'false'); }

  function showPopular() {
    seq++; if (ctrl) ctrl.abort();
    root.classList.remove('has-q', 'is-loading', 'is-empty');
    list.innerHTML = popularHTML; list.hidden = false; empty.hidden = true;
    title.textContent = defaultTitle;
    all.hidden = true; status.textContent = '';
    active = -1; input.removeAttribute('aria-activedescendant'); syncExpanded();
    title.hidden = !list.querySelector('[role="option"]');
  }
  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var prods = (r.products || []).slice(0, limit), colls = (r.collections || []).slice(0, 4);
    root.classList.remove('is-loading');
    all.href = searchUrl + '?q=' + encodeURIComponent(q);
    var n = prods.length;
    if (!n && !colls.length) {
      root.classList.add('is-empty');
      list.innerHTML = ''; list.hidden = true; empty.hidden = false; emptyQ.textContent = q;
      title.hidden = true; all.hidden = true;
      status.textContent = 'No results for ' + q;
    } else {
      root.classList.remove('is-empty');
      empty.hidden = true; list.hidden = false; title.hidden = false; all.hidden = false;
      var h = '';
      if (colls.length) h += '<div class="orn-srch__colls" role="group" aria-label="Collections">' + colls.map(function (c, i) { return collectionHTML(c, i, q); }).join('') + '</div>';
      if (n) h += '<div class="orn-srch__products" role="group" aria-label="Products">' + prods.map(function (p, i) { return productHTML(p, i, q); }).join('') + '</div>';
      list.innerHTML = h;
      title.textContent = n ? ((n >= limit ? 'Top ' + n + ' results' : n + (n === 1 ? ' result' : ' results')) + ' for “' + q + '”') : 'Collections for “' + q + '”';
      status.textContent = (n + colls.length) + ' suggestions available. Use the up and down arrows to browse.';
    }
    active = -1; input.removeAttribute('aria-activedescendant'); syncExpanded();
  }
  function search(q) {
    var key = q.toLowerCase();
    if (cache[key]) { seq++; if (ctrl) ctrl.abort(); render(q, cache[key]); return; }
    if (ctrl) ctrl.abort();
    var my = ++seq;
    ctrl = window.AbortController ? new AbortController() : null;
    root.classList.add('is-loading');
    var url = suggestUrl + '?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product%2Ccollection&resources%5Blimit%5D=' + limit + '&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { cache[key] = d; if (my === seq) render(q, d); })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        if (my !== seq) return;
        root.classList.remove('is-loading');
        // Network / rate-limit failure: keep it honest and point to the full search page
        list.innerHTML = ''; list.hidden = true; empty.hidden = true; title.hidden = false;
        title.textContent = 'Search for “' + q + '”'; all.hidden = false;
        all.href = searchUrl + '?q=' + encodeURIComponent(q);
        syncExpanded();
      });
  }
  function onInput() {
    var q = input.value.trim();
    clearBtn.hidden = !input.value;
    if (q === lastQ) return; lastQ = q;
    clearTimeout(timer);
    if (!q) { showPopular(); return; }
    root.classList.add('has-q');
    timer = setTimeout(function () { search(q); }, 150);
  }

  /* ---------- open / close ---------- */
  function lockScroll(on) { document.documentElement.classList.toggle('orn-srch-lock', on); }
  function open(from) {
    if (isOpen()) return;
    clearTimeout(closeT);
    opener = from || visibleTrigger();
    var ph = mqMobile.matches ? input.getAttribute('data-placeholder-mobile') : null;
    input.placeholder = ph || input.getAttribute('placeholder');
    root.hidden = false; root.classList.remove('is-closing');
    void root.offsetWidth;
    root.classList.add('is-open');
    lockScroll(true);
    triggers().forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    input.focus({ preventScroll: true }); // synchronous with the click/key so phones raise the keyboard
    if (input.value) input.select();
    document.addEventListener('keydown', onKey, true);
  }
  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    triggers().forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    setActive(-1);
    var done = function () { root.hidden = true; root.classList.remove('is-closing'); lockScroll(false); };
    if (reduce.matches) done(); else { root.classList.add('is-closing'); closeT = setTimeout(done, 200); }
    var back = opener && document.contains(opener) && opener.getClientRects().length ? opener : visibleTrigger();
    if (back) back.focus({ preventScroll: true });
    opener = null;
  }

  /* ---------- keyboard ---------- */
  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'), function (e) {
      return !e.hidden && !e.closest('[hidden]') && e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden';
    });
  }
  function onKey(e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
      return;
    }
    if (document.activeElement !== input) return;
    var o = options();
    if (e.key === 'ArrowDown') { e.preventDefault(); if (o.length) setActive(active < o.length - 1 ? active + 1 : 0); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); if (o.length) setActive(active > 0 ? active - 1 : o.length - 1); }
    else if (e.key === 'Enter' && active > -1 && o[active]) { e.preventDefault(); o[active].click(); }
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-orn-search-open]');
    if (t) { e.preventDefault(); e.stopPropagation(); open(t); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || isOpen() || e.ctrlKey || e.metaKey || e.altKey || e.defaultPrevented) return;
    var a = document.activeElement;
    if (a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return;
    if (!triggers().length) return;
    e.preventDefault();
    open(visibleTrigger());
  });
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-orn-search-close]');
    if (c) { e.preventDefault(); close(); return; }
    var term = e.target.closest('[data-orn-search-term]');
    if (term) { e.preventDefault(); input.value = term.getAttribute('data-orn-search-term'); lastQ = null; clearTimeout(timer); clearBtn.hidden = false; root.classList.add('has-q'); lastQ = input.value.trim(); search(lastQ); input.focus({ preventScroll: true }); }
  });
  clearBtn.addEventListener('click', function () { input.value = ''; onInput(); input.focus({ preventScroll: true }); });
  input.addEventListener('input', onInput);
  form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
  syncExpanded();

  // Theme editor: show the overlay while its section is selected
  document.addEventListener('shopify:section:select', function (e) { if (root.closest('.shopify-section') === e.target) open(visibleTrigger()); });
  document.addEventListener('shopify:section:deselect', function (e) { if (root.closest('.shopify-section') === e.target) close(); });
})();
